import { PUBLIC_FEATURE_FLAGS_REDUCER_KEY } from 'store/publicFeatureFlags/actions'
import { PublicFeatureFlagsState } from 'store/publicFeatureFlags/interfaces'

export const publicFeatureFlagsSelector = (state: {
  [PUBLIC_FEATURE_FLAGS_REDUCER_KEY]: PublicFeatureFlagsState
}) => state[PUBLIC_FEATURE_FLAGS_REDUCER_KEY]
